import React from 'react'
import Faq from './Faq'
import useFirstAddressWithTownSeoPostcode from '../useFirstAddressWithTownSeoPostcode'

const LayerCityFaq = () => {
  const { town, postcode } = useFirstAddressWithTownSeoPostcode()
  return <Faq faqParams={{ ville: town, cp: postcode }} />
}

export default LayerCityFaq
